import { Button } from '@mui/material';
import Iconify from 'src/components/iconify';

type Props = {
  onClick: any;
};
export default function ButtonRemoveFromBasket({ onClick }: Props) {
  return (
    <Button
      fullWidth
      variant="outlined"
      startIcon={<Iconify icon="gg:remove" />}
      color="error"
      onClick={onClick}
      sx={{
        typography: 'caption',
        fontWeight: 500,
        justifyContent: 'flex-start',
        border: '1px solid transparent',
      }}
    >
      Xóa khỏi giỏ
    </Button>
  );
}
